import {mapState} from 'vuex';
import 'firebase/storage';
import {EventsTypes} from '@/enums/EventsTypes';
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import TimePicker from '@/components/pickers/TimePicker.vue';
import moment from 'moment';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import Loader from "@/components/loader/Loader.vue";
import {dateFormats} from '@/consts/DateTimeFormats';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import {setTimeForDate} from '@/utils/dateTimeFormat';
import TimeRangeDropdown from "@/components/pickers/TimeRangeDropdown.vue";
import CancelCallDialog from "@/views/calender/view-calendar-item/CancelCallDialog.vue";
import {delay} from '@/utils/wait-resized-image';
import SingleTimeDropdown from "@/components/pickers/SingleTimeDropdown.vue";
import { CallsTypes } from '@/enums/CallsTypes';

export default {
    name: 'ViewScheduledCall',
    components: {
        VueTimepicker,
        TimePicker,
        ConfirmDlg,
        CoolLightBox,
        Loader,
        TimeRangeDropdown,
        CancelCallDialog,
        SingleTimeDropdown
    },
    data: () => ({
        menu1: false,
        menu2: false,
        menu3: false,
        viewCall: { 
            scheduledAt: null,
            imageUrl: '',
            name: '',
            description: '',
            start: null,
            end: null
        },
        flexHeight: 500,
        readonly: true,
        durationVal: null,
        minDate: moment(new Date()).format('YYYY-MM-DD'), //today
        maxDate: moment(new Date()).add(1, "year").format("YYYY-MM-DD"),
        hintDateHormat: '',
        hintTimeHormat: '',
        eventsTypes: EventsTypes,
        EventsTypesOptions: [],
        isScheduledDateValid: true,
        endDateTimeValid: true,
        loading: true,
        saving: false,
        scheduledAtTime: null,
        startTime: null,
    }),

    computed: {
        ...mapState({
            currentCall() {
                return this.$store.state.callsModule.currentCall;
            },
            currentFacility() {
                return this.$store.state.authModule.currentFacility;
            },
            facility() {
                return this.$store.state.facilityModule.selectedFacility;
            },
            CallsTypes() {
                return CallsTypes;
            },
            callCreator(){
                return this.currentCall.participants.find(participant =>participant.isHost === true)
            },
            callParticipants() {
                return this.currentCall.participants
            }
        }),
        scheduledAt: {
            set(value) {
                const date = moment(value)
                const time = this.scheduledAtTime
                
                setTimeForDate(date, time)
                this.viewCall.scheduledAt = date.toDate()
            },
            get() {
                return moment(this.viewCall.scheduledAt).format('YYYY-MM-DD');
            }
        },
       
        imageUrl: {
            get() {
                return this.currentCall?.imageUrl;
            },
            set(value) {
                this.viewCall.imageUrl = value;
            },
        },
        name: {
            get() {
                return this.currentCall?.name
            },
            set(value) {
                this.viewCall.name = value;
            },
        },
        isCallInPast(){
          return moment(this.currentCall.scheduledAt).isBefore(moment());
        },
        formattedScheduledDate() {
            if (!this.hintDateHormat) return ''

            return moment(this.scheduledAt).format(this.hintDateHormat)
        },
        formattedScheduledDateTime(){
            return moment(this.currentCall.scheduledAt).format(this.facility.dateFormat  + ' ' + this.facility.timeFormat)
        }
    },
    async mounted() {
        try {
            this.loading = true;
            const id = this.$route.params.id

            await this.$store.dispatch('getFacility');
            await this.$store.dispatch('getCallById', id);

            this.viewCall = { ... this.currentCall };
            const dateFormat = dateFormats.find(x => x.format == this.facility.dateFormat)
            this.hintDateHormat = dateFormat ? dateFormat.name : dateFormats[0].name
            this.hintTimeHormat = this.facility.timeFormat.includes('A') ? this.facility.timeFormat.replace(' A', '') : this.facility.timeFormat
            this.scheduledAtTime = moment(this.currentCall.scheduledAt).format(this.facility.timeFormat)
            this.startTime = this.currentCall.callType === CallsTypes.RealtimeCall? moment(this.currentCall.start).format(this.facility.timeFormat) : null
            this.checkRouteParams();

            this.loading = false;

        } catch (e) {
            console.error('mounted() error: ', e);
        }
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    methods: {
        onDatePickerInput(value) {
            this.menu1 = false;
            this.validateScheduledAt(value);
        },
        onScheduledAtTimeChange(value){
            this.scheduledAtTime = value.time
            setTimeForDate(this.viewCall.scheduledAt, this.scheduledAtTime)
        },
        routeToCalender() {
            const {residentId, isVideoCallEnabled} = this.$route.params;
            const params: any = {};

            if (residentId) {
                params.name = 'ResidentView';
                params.params = {id: residentId};
            } else {
                params.name = 'Calendar';
                params.params = {
                    isVideoCallEnabled,
                    currentWeek: this.currentCall.scheduledAt,
                };
            }

            this.$router.push(params);
        },
        async onCancelCall(cancelReason){

            await this.$store.dispatch('cancelScheduldCall', { id: this.$route.params.id, cancelReason: cancelReason })
            
            this.$toast.open({
                message: this.$t('ViewCalendarItem.CallSuccessfullyCanceled'),
                type: "success"
            });

            delay(1000).then(() => {
                this.routeToCalender()
            });
        },
        async saveChanges() { 
            const validatedDateTime = this.validateScheduledAt();

            if (!validatedDateTime) return;

            this.saving = true
           
            const updateData: any = {
                name: this.viewCall.name,
                scheduledAt: this.viewCall.scheduledAt,
            }

            await this.$store.dispatch('updateCall', { id: this.currentCall.id, data: updateData}).then(() => {
                this.readonly = true;
                this.saving = false
            });
        },
        cancelCall(){
            (this.$refs.cancelCallDialog as any).open()
        },
        editMode() {
            if (this.readonly) {
                Object.assign(this.viewCall, this.currentCall);
            }
            this.readonly = !this.readonly;
        },
        validateScheduledAt(value) {
            let scheduledAt = null

            if (value && typeof value === 'string') {
              scheduledAt = moment(value, 'YYYY-MM-DD', true);
            } else {
              scheduledAt = moment(this.scheduledAt, 'YYYY-MM-DD', true);
            }

            const isValid = scheduledAt.isValid();
            this.isScheduledDateValid = isValid

            return isValid
        },
        onChangeSheduledAt(value){
            this.validateScheduledAt(value)
        },
        onChangeStartDate(value){
            this.validateStartDate(value)
        },
        checkRouteParams() {
            const routeParams = this.$route.params;

            if (routeParams.isEdit) {
                this.editMode();
            }
        }
    }
};
